import { useQuery } from '@tanstack/react-query';
import { fetchResults, type ResultQueryParams } from '../services/resultApi';

const RESULT_STALE_TIME_MS = 5 * 60 * 1000;
const RESULT_GC_TIME_MS = 30 * 60 * 1000;

export function useResultsQuery(
  eventId: number | null,
  params: ResultQueryParams = {}
) {
  return useQuery({
    queryKey: ['results', eventId, params],
    queryFn: () => fetchResults(eventId ?? 0, params),
    enabled: eventId != null && params.categoryId != null,
    staleTime: RESULT_STALE_TIME_MS,
    gcTime: RESULT_GC_TIME_MS,
    refetchOnWindowFocus: false,
  });
}
